import React, { useState } from 'react'
import { Button, message, Upload, Form, Input, Modal } from 'antd'
import axios from 'axios'
import { saveAs } from 'file-saver'
import { InboxOutlined } from '@ant-design/icons';

const { Dragger } = Upload;

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const App = () => {
  const [fileList, setFileList] = useState([])
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  const [uploading, setUploading] = useState(false)
  const [imageUrl, setImageUrl] = useState('')
  const [blob, setBlob] = useState(null)
  const [row] = useState('2')
  const [column] = useState('3')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const NumericInput = (props) => {
    const { onChange } = props
    const handleChange = (e) => {
      const { value: inputValue } = e.target
      const reg = /^\d*(\d*)?$/
      if (reg.test(inputValue) || inputValue === '') {
        onChange(inputValue)
      }
    }
    return (
      <Input
        {...props}
        onChange={handleChange}
        placeholder="请输入正整数"
        maxLength={2}
      />
    )
  }
  const handleCancelPreview = () => setPreviewOpen(false);
  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
    setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1));
  };
  const handleUpload = (row, column) => {
    const formData = new FormData()
    fileList.forEach((file) => {
      formData.append('images', file.originFileObj)
    })
    formData.append('row', row)
    formData.append('column', column)
    setUploading(true)
    // axios
    // 使用axios发送POST请求进行多文件上传
    axios
      .post('/upload/mergeImage', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        responseType: 'arraybuffer'
      })
      .then((res) => {
        setBlob(res.data)
        setImageUrl(
          'data:image/png;base64,' +
            btoa(
              new Uint8Array(res.data).reduce(
                (previousValue, currentValue) =>
                  previousValue + String.fromCharCode(currentValue),
                ''
              )
            )
        )
        // setFileList([])
        setIsModalOpen(true)
        message.success('上传成功')
      })
      .catch((error) => {
        message.error('上传失败')
        console.log(error)
      })
      .finally(() => {
        setUploading(false)
      })
  }
  // form回调方法
  const onFinish = (values) => {
    const row = values.row
    const column = values.column
    handleUpload(row, column)
  }
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo)
  }
  // Modal回调方法
  const handleOk = () => {
    setIsModalOpen(false)
    saveAs(new Blob([blob], { type: 'image/jpeg' }), '拼接图.jpg') // 设置下载文件名
  }
  const handleCancel = () => {
    setIsModalOpen(false)
  }
  const handleChange = ({ fileList: newFileList }) => setFileList(newFileList);
  // 上传按钮属性
  const props = {
    multiple: true,
    onRemove: (file) => {
      const index = fileList.indexOf(file)
      const newFileList = fileList.slice()
      newFileList.splice(index, 1)
      setFileList(newFileList)
    },
    beforeUpload: (file) => {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
      if (!isJpgOrPng) {
        message.error('只能上传jpg或png格式!')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!isLt2M) {
        message.error('上传文件最大10MB!')
        return false
      }
      return false
    },
    listType: "picture-card",
    onChange: handleChange,
    onPreview: handlePreview,
    fileList
  }
  return (
    <>
      <Dragger {...props} style={{marginBottom: 30}}>
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">点击或拖曳文件上传</p>
        <p className="ant-upload-hint">
          支持单图与多图上传，并且支持拖曳
        </p>
      </Dragger>
      <Form
        name="basic"
        labelCol={{
          span: 4
        }}
        wrapperCol={{
          span: 16
        }}
        style={{
          marginTop: '20px'
        }}
        initialValues={{
          row,
          column
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item
          label="行数"
          name="row"
          validateTrigger="onBlur"
          rules={[
            {
              required: true,
              message: '请输入行数'
            }
          ]}
        >
          <NumericInput />
        </Form.Item>
        <Form.Item
          label="列数"
          name="column"
          validateTrigger="onBlur"
          rules={[
            {
              required: true,
              message: '请输入列数'
            }
          ]}
        >
          <NumericInput />
        </Form.Item>
        <Form.Item
          wrapperCol={{
            offset: 9,
            span: 4
          }}
        >
          <Button
            type="primary"
            htmlType="submit"
            disabled={fileList.length < 2}
            loading={uploading}
            style={{
              marginTop: 16
            }}
          >
            {uploading ? '上传中' : '开始上传'}
          </Button>
        </Form.Item>
      </Form>
      <Modal
        title="转换结果"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="下载"
        cancelText="取消"
      >
        <img
          src={imageUrl}
          alt="preview"
          style={{
            width: '100%'
          }}
        />
      </Modal>
      <Modal open={previewOpen} title={previewTitle} footer={null} onCancel={handleCancelPreview}>
        <img
          alt={previewTitle}
          style={{
            width: '100%',
          }}
          src={previewImage}
        />
      </Modal>
    </>
  )
}
export default App
